/* "Volver arriba". El boton lo dibuja sections/vd-footer.liquid.
   Aparece pasado casi un alto de pantalla (nunca menos de 600px) para no
   estorbar en el primer vistazo; al pulsarlo lleva el foco a <main> para que
   quien navega con teclado o lector no quede perdido abajo. */
(() => {
  const btn = document.getElementById('vd-top');
  if (!btn) return;

  const threshold = () => Math.max(600, window.innerHeight * 0.9);
  let shown = false;

  // Sin requestAnimationFrame a proposito: la comprobacion es una lectura de
  // scrollY y un toggle que solo escribe cuando cambia el estado, y rAF no
  // corre en pestanas ocultas, lo que dejaba el boton sin aparecer.
  const update = () => {
    const on = window.scrollY > threshold();
    if (on !== shown) {
      shown = on;
      btn.hidden = !on;
    }
  };

  window.addEventListener('scroll', update, { passive: true });
  update();

  btn.addEventListener('click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    const main = document.getElementById('MainContent');
    if (main) main.focus({ preventScroll: true });
  });
})();
